import { useState } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import AlertBox from "../AlertBox";
import { downloadAuditLogsApi } from "../../api/setting";
import { LOG_TYPE } from "../../tools/audittools";

export default function ModalDownloadAuditLogs({ show, onClose, onSuccess }) {
  let [form, setForm] = useState({
    q: "",
    start_date: moment().subtract(3, "months").format("YYYY-MM-DD"),
    end_date: moment().format("YYYY-MM-DD"),
    action_type: "",
  });
  let [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const handleDateChange = (type, value) => {
    setAlert({ show: false, message: "", type: "" });
    let newStartDate = form.start_date;
    let newEndDate = form.end_date;

    if (type === "start_date") {
      newStartDate = value;
      if (moment(newEndDate).diff(moment(newStartDate), "months", true) > 3) {
        newEndDate = moment(newStartDate).add(3, "months").format("YYYY-MM-DD");
      }

      if (moment(newStartDate).isAfter(newEndDate)) {
        newEndDate = newStartDate;
      }
    } else if (type === "end_date") {
      newEndDate = value;
      if (moment(newEndDate).diff(moment(newStartDate), "months", true) > 3) {
        newStartDate = moment(newEndDate).subtract(3, "months").format("YYYY-MM-DD");
      }
      if (moment(newEndDate).isBefore(newStartDate)) {
        newStartDate = newEndDate;
      }
    }
    setForm({ ...form, start_date: newStartDate, end_date: newEndDate });
  };

  const handleClose = () => {
    setForm({
      q: "",
      action_type: "",
      start_date: moment().subtract(3, "months").format("YYYY-MM-DD"),
      end_date: moment().format("YYYY-MM-DD"),
    });
    setAlert({ show: false, message: "", type: "" });
    onClose(false);
  };

  const submitData = (event) => {
    event.preventDefault();
    const startDate = moment(form.start_date, "YYYY-MM-DD");
    const endDate = moment(form.end_date, "YYYY-MM-DD");

    if (!startDate.isValid() || !endDate.isValid()) {
      setAlert({ show: true, message: "Format tanggal tidak valid.", type: "danger" });
      return;
    }

    if (endDate.diff(startDate, "months", true) > 6) {
      setAlert({
        show: true,
        message: "Rentang tanggal tidak boleh lebih dari 6 bulan.",
        type: "danger",
      });
      return;
    }
    if (startDate.isAfter(endDate)) {
      setAlert({
        show: true,
        message: "Tanggal mulai tidak boleh setelah tanggal akhir.",
        type: "danger",
      });
      return;
    }
    setAlert({ show: false, message: "", type: "" });
    triggerDownload(form);
  };

  const triggerDownload = async (formData) => {
    setLoading(true);
    try {
      const params = {};
      if (formData.q) params.q = formData.q;
      if (formData.start_date) params.start_date = formData.start_date;
      if (formData.end_date) params.end_date = formData.end_date;
      if (formData.action_type) params.action_type = formData.action_type;

      let response = await downloadAuditLogsApi(params);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "audit log.csv");
      if (onSuccess) {
        onSuccess("Berhasil mengunduh audit log.csv");
      }
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      handleClose();
    } catch (error) {
      let message = "Something went wrong ... ";
      if (error.response) {
        let { data } = error.response;
        let responseObj = await data.text();
        let responseData = JSON.parse(responseObj);
        message = responseData?.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message: message, type: "danger" });
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <form onSubmit={(event) => submitData(event)}>
        <Modal.Header closeButton>
          <Modal.Title>Download Audit Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AlertBox {...alert} setAlert={setAlert} />
          <div className="form-group">
            <label>Kata Kunci</label>
            <input
              type="text"
              className="form-control"
              value={form.q}
              onChange={(event) => setForm({ ...form, q: event.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Tipe</label>
            <select
              className="form-control"
              value={form.action_type}
              onChange={(event) => setForm({ ...form, action_type: event.target.value })}
            >
              <option value="">ALL</option>
              {Object.keys(LOG_TYPE).map((key) => (
                <option value={key} key={key}>
                  {LOG_TYPE[key]}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Waktu Mulai</label>
            <input
              type="date"
              className="form-control"
              value={form.start_date}
              onChange={(event) => handleDateChange("start_date", event.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Waktu Akhir</label>
            <input
              type="date"
              className="form-control"
              value={form.end_date}
              onChange={(event) => handleDateChange("end_date", event.target.value)}
              max={moment().format("YYYY-MM-DD")}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" type="button" onClick={() => handleClose()}>
            Close
          </button>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            <i className="fas fa-download"></i> {!loading ? "Unduh Data" : "Harap Tunggu ..."}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
